export default "__VITE_ASSET__CcAffjxf__"